export enum NotificationType {
  ACTION = 'ACTION',
  INFO = 'INFO',
}

export interface NotificationRecipient {
  id: string;
  readAt: string | null;
  createdAt: string;
  notification: Notification;
}

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  body: string | null;
  redirectionLink: string | null;
  createdAt: string;
  company?: { id: string };
  process: string | null;
  job: string | null;
}

export interface NotificationsResponse {
  recipients: NotificationRecipient[];
  hasMore: boolean;
}
